import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import MoreAdminSvgComponent from "../../../../assets/svg-components/left-menu/more-admin";
import InputField from "@_common/InputRuleFeild";
import React, { useEffect, useState } from "react";
import { QueryRequestHelper } from "@_common/query-request-helper";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import {
  GetVendorLocationData,
  GetVendorUserLocation,
  deleteVendorUserLocation,
  updateVendorUserLocation,
} from "@services/checkpoint.service";
import { useParams } from "react-router-dom";
import moment from "moment";
import {
  clientGetFunction,
  clientGetLocation,
  clientUnAttachedLocation,
  clientUpAttachedLocation,
} from "@services/location.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import { convertCurrentDate, convertDate } from "@_common/date-helpers";
import DeleteModal from "@_common/deleteModal";
import PaginationPage from "@components/pagination/pagination";
import SearchableDropdownSelect from "@_common/SearchableDropdown";

interface IAdminUserLocationMappingProps {}

// export default function AdminUserLocationMapping(props: any) {
const AdminUserLocationMapping: React.FunctionComponent<
  IAdminUserLocationMappingProps
> = (props: any) => {
  let orgParams = useParams();

  let navigate = useNavigate();
  const [date, setDate] = useState<Date | null>(null);
  const [locationList, setLocationList] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState<any>("");
  const [isLoading, setIsLoading] = React.useState(false);



  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
        getData();
      getAllLocations();
      getLocationData();
    // }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      let selectedIDs: any = urlSearchParams.getAll("industries[]");
      getData();
      getAllLocations();
      getLocationData();
      
      if (params.page_no) {
				setPage_no(parseInt(params.page_no));
			}


    }
  }, [window.location.href, props.permissionAPITriggered]);

  // Tags List
  const [tagsList, setTagsList] = useState([]);
  const [selectedTagsListIds, setSelectedTagsListIds] = useState<any>([]);
  const handleChangeTagsMulti = (e: any) => {
    setSelectedTagsListIds(e);
  };

  const getAllLocations = async () => {
    let payload: any = {
      page_no: 1,
      page_size: 100,
      user_id: getValue(orgParams, `id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    // let locations = await clientGetLocation(queryRequest);
    // let resp = await clientUpAttachedLocation(
    //     getValue(orgParams, `id`, ""),
    //     queryRequest
    //   );
    let resp = await clientUnAttachedLocation(
      queryRequest
    ); 
    if (resp) {
      setTagsList(
        getValue(resp, `data.locations`, []).map((item: object) => ({
          value: getValue(item, `location_name`, ""),
          label: getValue(item, `location_name`, ""),
          id: getValue(item, `id`, ""),
        }))
      );
    }
  };


  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getLocationData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: 1,
      page_size: 10,
      user_id: getValue(orgParams, `id`, ""),
    };

    let queryRequest = QueryRequestHelper(payload);
    try {
      // let resp = await clientUpAttachedLocation(
      //   getValue(orgParams, `id`, ""),
      //   queryRequest
      // ); 

      let resp = await clientUnAttachedLocation(
        queryRequest
      ); 

      if (resp) {
        setIsLoading(false);
        let filtered = getValue(resp, `data.locations`, []).map(
          (item: object) => ({
            ...item,
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
            id: getValue(item, `id`, ""),
          })
        );

        setLocationList(getValue(filtered, `length`, 0) > 0 ? filtered : []);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };



   /* -------------------------------------------------------------------------- */
  /*                      New Location Search Section                           */
  /* -------------------------------------------------------------------------- */

  const [searchLoading, setSearchLoading] = useState(false);
  const handleTriggerAPI = async (value: string) => {

    let payload: any = {
      search_text: value,
      page_no: 1,
      user_id: getValue(orgParams, `id`, ""),
      page_size: 10,
    };
    setSearchLoading(true);
    let queryRequest = QueryRequestHelper(payload);
    try {
      // let resp = await clientUpAttachedLocation(
      //   getValue(orgParams, `id`, ""),
      //   queryRequest
      // );    
      let resp = await clientUnAttachedLocation(
        queryRequest
      );
      
      if (resp) {
        setLocationList(
          getValue(resp, `data.locations`, []).map((item: object) => ({
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
            id: getValue(item, `id`, ""),
          }))
        );
        setSelectedLocation("");
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const handleClick = (e: any) => {
    setSelectedLocation(e);
    handleAdd(e);
  };

  const handleAdd = async (value: object) => {
    setSelectedLocation(value);
  };

  const handleSubmit = async () => {
    let payload = {
      user_id: getValue(orgParams, `id`, ""),
      // location_id: selectedTagsListIds.map((tag: any) => tag.id),
      location_id: [getValue(selectedLocation, `id`, "")] ,
    };

    console.log(selectedLocation);
    console.log(payload);

    try {
      let resp = await updateVendorUserLocation(payload);
      toast.success(getValue(resp, `message`, ""));
      setSelectedLocation([]);
      setSelectedTagsListIds([]);
      getData();
      getLocationData();
    } catch (error) {}
  };

  const handleReset = () => {
    setSelectedTagsListIds([]);
    setSelectedLocation([]);
  };

  const handleNavigateBack = () => {
      navigate(
        `/admin/users`
      );
  };

  const [loading, setLoading] = useState(true);
  const [templateList, setTemplateList] = useState([]);


  const columns = React.useMemo(
    () => [
      
      {
        Header: "Location",
        accessor: "location_name",
        width: 400,
      },
      {
        Header: "User",
        accessor: "user_name",
        width: 400,
      },
      {
        Header: "Action",
        width: 80,
        Cell: ({ row }: any) => {
          return (
            <div className="ms-2">
              <img
                src="/images/list-management/country/delete-icon.svg"
                className="img-fluid close-btn cursor-pointer"
                onClick={() =>
                  handleDeleteEntity(
                    getValue(row, `original.id`, ""),
                    ""
                  )
                }
                style={{
                  height: "30px",
                  width: "30px",
                }} />
            </div>
          );
        },
      },
    ],
    []
  );

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    
    try {
      let payload = {
        user_id: getValue(orgParams, `id`, ""),
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setLoading(true);
      let resp = await GetVendorUserLocation(queryRequest);
      if (resp) {
        setTemplateList(
          getValue(resp, `data.locations`, []).map((item: object) => ({
            ...item,
            created_at: convertCurrentDate(getValue(item, `createdAt`, "")),
            user_name: `${getValue(item, 'users[0].first_name', '')} ${getValue(item, 'users[0].last_name', '')}`
          }))
        );
  
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };


  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      templateList.length > 0
        ? templateList.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const rowClick = (obj: object) => {
  };
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        // style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
    return {};
  };

    /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteEntity = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    let payload = {
      user_id: getValue(orgParams, `id`, ""),
      location_id: [deleteId], // Convert to string if required
    };
    // let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await deleteVendorUserLocation(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  return (
    <>
      <DashboardLayout
        permissions={getValue(props, `tabPermissionList`, [])}
        subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
      >
        <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div 
            onClick={handleNavigateBack} 
            className="cursor-pointer me-2">
              <img
                src="/images/back-link.svg"
                className="img-fluid add-filter-wrapper__upload-image"
              />
            </div>

            <div className="header-parent-icon-holder">
              <MoreAdminSvgComponent />
            </div>

            <div className="title-wrapper">
              <h6 className="dashbaord-wrapper__header-parent-title">Admin</h6>
              <h4 className="dashbaord-wrapper__header-title">
                Users Location Mapping
              </h4>
            </div>
          </div>
        </div>

        <div className="main-page-layout-wrapper">
          <div className="user-entity-mapping-filter-card">
            <div className="filter-form-wrappper w-100 active">
              <div className="filter-form-wrappper__container">
                <div className="filter-body-wrapper" style={{paddingRight: "16px"}}>
                  <div className="filter-body-card">
                    <div className="">
                      <div className="dashboard-self-compliance dashboard-content-holder">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap w-100">
                          <div className="dashboard-fields-label mb-1">Location</div>
                          {/* <div className="filter-form-wrappper__location-input select-dd-new w-100">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Location"
                              className="form-control w-100"
                              name="location_id"
                              id="location_id"
                              label="Location"
                              options={tagsList}
                              value={selectedTagsListIds}
                              onChange={(e: any) => handleChangeTagsMulti(e)}
                              isMulti
                            />
                          </div> */}

                          <div className="filter-form-wrappper__location-input searchable-dd-w-100 w-100">
                          <SearchableDropdownSelect
                            placeholder={"Choose Location"}
                            options={locationList}
                            searchLoading={searchLoading}
                            handleChange={(val: any) => handleTriggerAPI(val)}
                            handleClick={handleClick}
                            value={selectedLocation}
                            label="label"
                            id="id"
                            name="Location"
                            className="form-control w-100"
                          />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end align-items-center">
                <div className="filter-form-wrappper__cta-wrapper">
                  <button
                    className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                    onClick={() => handleReset()}
                  >
                    Reset
                  </button>

                  <button
                    className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search location-mapping-add-button"
                    onClick={() => handleSubmit()}
                    disabled={selectedLocation.length === 0} // Disable if the array is empty
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>

          {loading ? (
              <Loader />
            ) : getValue(templateList, `length`, 0) > 0 ? (
              <div className="admin-wrapper position-relative user-entity-mapping-table-wrap user-location-mapping mt-3">
                <ScrollableDataTable
                  columns={columns}
                  data={templateList}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  checkboxlogo
                  getTrProps={getTrProps}
                />
              </div>
            ) : (
              <Notfound />
            )}

            <div className="footer-wrapper d-flex justify-content-between">
                {templateList.length > 0 && (
                  <img
                    src="/images/building-illustration.svg"
                    className="img-fluid"
                  />
                )}
                {totalCount > 10 ? (
                  <PaginationPage
                    totalCount={totalCount}
                    limit={limit}
                    pageNumber={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                ) : (
                  <p className="show-rows-count mt-3 d-flex">
                    Total Count:&nbsp;&nbsp;{" "}
                    <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                  </p>
                )}
              </div>
        </div>
      </DashboardLayout>

      <DeleteModal
        isOpen={isDelete}
        handleModal={handleDelete}
        handleSubmit={handleDeleteFunction}
        deleteValue={deleteValue}
      />
    </>
  );
};

export default AdminUserLocationMapping;
